import React, { useCallback, useMemo, useRef } from "react";
import styles from "./Style.module.css";
import { Doughnut } from "react-chartjs-2";
import { Typography } from "@mui/material";
import { removeUnderScore } from "../../../../helper/Helper";
import NoDataFound from "../NoDataFound/NoDataFound";
import { FileDownloadOutlined } from "@mui/icons-material";

const options = {
  responsive: false,
  cutout: "90%",
  cutoutPercentage: 80,
  rotation: 1 * Math.PI,
  circumference: 1 * Math.PI,
  legend: {
    display: false,
  },
  tooltips: {
    enabled: true,
  },
  elements: {
    arc: {
      borderWidth: 0.5,
      cornerRadius: 10,
      borderSkipped: (ctx) => (ctx.raw.angle > Math.PI ? 20 : 0),
    },
  },
};

const labelPlugin = {
  id: "customLabels",
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((arc, index) => {
        const data = dataset.data[index];
        const label = chart.data.labels[index];

        const { x, y } = arc.getCenterPoint();

        ctx.save();
        ctx.fillStyle = "white";
        ctx.font = "bold 12px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        ctx.fillText(data, x, y);
        ctx.restore();
      });
    });
  },
};

const colors = {
  PRODUCT_CODE: "#F99C55",
  SCAN_CODE: "#3CA9E1",
  MYDOC: "#004DC1",
};
const EnrolementMode = ({ enrollData = [], isImgDownload = false }) => {
  const chartRef = useRef();

  const CustomLegend = ({ colors }) => {
    return (
      <div className={styles.legendContainer}>
        {enrollData?.map((val, index) => (
          <div key={val?.label} className={styles.legendItem}>
            <span
              className={styles.legendDot}
              style={{ backgroundColor: colors[val?.label] }}
            ></span>
            {removeUnderScore(val?.label)}
          </div>
        ))}
      </div>
    );
  };

  const data = {
    labels: enrollData?.map((val) => removeUnderScore(val?.label)),

    datasets: [
      {
        data: enrollData?.map((val) => val?.enrollment),
        backgroundColor: enrollData?.map((val) => colors[val?.label]),
        borderColor: [],
        borderWidth: 0.5,
        hoverOffset: 4,
        cutout: "90%",
      },
    ],
  };

  const totalEnrollment = useMemo(() => {
    return enrollData
      ? enrollData?.reduce((sum, item) => sum + (item?.enrollment ?? 0), 0)
      : 0;
  }, [enrollData]);

  const handleDownload = useCallback(() => {
    if (!chartRef.current) return;

    const chart = chartRef.current;
    const canvas = chart.chartInstance.canvas;
    const ctx = canvas.getContext("2d");

    const paddingTop = 40;
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height + paddingTop;
    const tempCtx = tempCanvas.getContext("2d");

    tempCtx.fillStyle = "white";
    tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

    tempCtx.fillStyle = "#636578";
    tempCtx.font = "bold 16px Arial";
    tempCtx.textAlign = "left";
    tempCtx.textBaseline = "top";
    tempCtx.fillText("Enrollment Mode", 10, 10);

    tempCtx.drawImage(canvas, 0, paddingTop);

    const url = tempCanvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `Enrollment Mode.png`;
    a.click();
  }, [chartRef]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.dFlex}>
          <Typography variant={"h5"} className={"heading"}>
            Enrollment Mode
          </Typography>
          {isImgDownload && (
            <FileDownloadOutlined
              onClick={handleDownload}
              color="primary"
              fontSize="small"
              className={styles.downloadIcon}
            />
          )}
        </div>

        <div className={styles.quaterWrap}>
          <CustomLegend colors={colors} />
        </div>
      </div>
      {enrollData?.length > 0 ? (
        <div className={styles.statusContainer}>
          <div className={styles.containerInner}>
            <Doughnut
              data={data}
              options={options}
              height={"150px"}
              ref={chartRef}
              width={"450px"}
              plugins={[labelPlugin]}
            />
            <div className={styles.divContainer}>
              <div className={styles.title21}>{totalEnrollment}</div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.noDataFound}>
          <NoDataFound />
        </div>
      )}
    </div>
  );
};

export default EnrolementMode;
